import {
  VIEWPORT_MEDIA_QUERIES,
  getViewportLayout,
  type ViewportLayout,
} from '../constants/viewport'
import { useUiPresentationStore } from '@store'
import { useEffect, useState } from 'react'

function readLayoutFromMedia(): ViewportLayout {
  if (typeof window === 'undefined') return 'desktop'

  if (window.matchMedia(VIEWPORT_MEDIA_QUERIES.desktop).matches) return 'desktop'
  if (window.matchMedia(VIEWPORT_MEDIA_QUERIES.tabletH).matches) return 'tabletH'
  if (window.matchMedia(VIEWPORT_MEDIA_QUERIES.tabletV).matches) return 'tabletV'
  if (window.matchMedia(VIEWPORT_MEDIA_QUERIES.mobile).matches) return 'mobile'

  return getViewportLayout(window.innerWidth)
}

/**
 * Detecta el layout del viewport vía matchMedia (única fuente de breakpoints).
 * No mete lógica de negocio: solo presentación.
 *
 * Correspondencia: ATEMPORAL mobile-28-07-2026 (`47ee2081`).
 */
export function useViewportLayout(): ViewportLayout {
  const [layout, setLayout] = useState<ViewportLayout>(() => readLayoutFromMedia())

  useEffect(() => {
    if (typeof window === 'undefined') return

    const queries = Object.values(VIEWPORT_MEDIA_QUERIES).map((q) => window.matchMedia(q))

    const sync = () => setLayout(readLayoutFromMedia())
    sync()

    for (const mq of queries) {
      mq.addEventListener('change', sync)
    }

    return () => {
      for (const mq of queries) {
        mq.removeEventListener('change', sync)
      }
    }
  }, [])

  return layout
}

/**
 * Sincroniza el layout detectado hacia `useUiPresentationStore`.
 * Llamar una sola vez en el shell del planner (ResponsiveShell / ViewerManager).
 */
export function useSyncViewportLayout(): ViewportLayout {
  const layout = useViewportLayout()
  const setLayout = useUiPresentationStore((s) => s.setLayout)

  useEffect(() => {
    setLayout(layout)
  }, [layout, setLayout])

  return layout
}
